import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import GroupClass from './GroupClass';
import GroupClassesList from './GroupClassesList';

const GroupClassesHandler = () => {
    const businessId = useSelector((state) => { return (state.buisnessDetails.businessId) })
    const basePath = `/dashboard/${businessId}/Group-Classes`
    return (
        <Switch>
            <Route exact path = {basePath} render = {()=>(<GroupClassesList basePath = {basePath} />)}/>
            <Route exact path = {`${basePath}/:classIdURL`} render = {()=>(<GroupClass basePath = {basePath}/>)}/>
            <Route path='*' render={() => { return (<Redirect to='/404' />) }} />
        </Switch>
    );
}

export default GroupClassesHandler;